import { useQuery } from "@tanstack/react-query";
import { ActiveAntsWarehouseCheckInService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { ISOString } from "src/types";

export const useActiveAntsWarehouseCheckIn = (
  activeAntsWarehouseCheckInId: string,
  timestamp: ISOString,
  activeAntsWarehouseCheckInService: ActiveAntsWarehouseCheckInService
) => {
  const {
    data: activeAntsWarehouseCheckIn,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.activeAntsWarehouseCheckIn(activeAntsWarehouseCheckInId, timestamp),
    queryFn: async () => {
      try {
        return await activeAntsWarehouseCheckInService.getActiveAntsWarehouseCheckInById(
          activeAntsWarehouseCheckInId,
          timestamp
        );
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!activeAntsWarehouseCheckInId,
    retry: false
  });

  return { activeAntsWarehouseCheckIn, fetchError, isLoading, refetch };
};
